exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#filmUploadSuccess {\n  width: 300px;\n  position: fixed;\n  top: 25px;\n  left: 25px;\n  z-index: 1000;\n}\n", ""]);

// exports
